import { useEffect } from 'react';
/**
 * Wrapper hook to that passes an isMountedFunction to given effect function
 * to be used to determine if the effect should still be active
 * Useful for effects that may have asyncronous code that might still run after a traditional cleanup phase
 * @param effectFunc Effect function to run
 */
export function useIsMounted(effectFunc) {
    useEffect(function () {
        var mounted = true;
        var isMounted = function () { return mounted; };
        var cleanup = effectFunc(isMounted);
        return function () {
            mounted = false;
            if (cleanup) {
                cleanup();
            }
        };
    }, [effectFunc]);
}
//# sourceMappingURL=useIsMounted.js.map